import useOutsideClickDetection from '../hooks/useOutsideClickDetection';
import React, { useRef } from 'react';
import PopUpDialog from './PopUpDialog';

export default function Dialog({ children, itemType, onClickOutside, ...other }) {
  const popupMenuRef = useRef(null);

  useOutsideClickDetection(() => {
    typeof onClickOutside === 'function' && onClickOutside();
  }, [popupMenuRef]);

  return (
    <PopUpDialog ref={popupMenuRef} {...other}>
      {children}
    </PopUpDialog>
  )
}
